import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Spinner } from '@salesforce/design-system-react';
import formatTimestamp from '../../../i18n/formatTimestamp';
import { AuditTable, ProfileStatus } from '../';

import './SelectionProfileStatus.scss';

class SelectionProfileStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusPopupIsOpen: false,
      statusChanged: false,
      tempStatus: this.props.profile.processingStatus
    };
  }

  getI18nID(suffix) {
    return `components.ecs.selectionBrowser.profile.${suffix}`;
  }

  drawSpinner(isLoading) {
    return isLoading ? (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    ) : null;
  }

  render() {
    const { formatMessage } = this.props.intl;
    const formatDate = formatTimestamp(this.props.intl);
    const currentStatus =
      this.props.profile?.processingStatus?.toLowerCase() || 'standard';

    if (this.props.profile.createdAt !== null)
      return (
        <div className="profile-status-pane">
          <div className="profile-current">
            <ul>
              <li>
                {formatMessage({ id: this.getI18nID('audit.currentStatus') })} -{' '}
                {formatMessage({ id: this.getI18nID(`${currentStatus}`) })}
              </li>
              <li>
                {formatMessage({ id: this.getI18nID('audit.updatedAt') })} -{' '}
                {formatDate(this.props.profile.updatedAt)}
              </li>
              <li>
                {formatMessage({ id: this.getI18nID('audit.createdAt') })} -{' '}
                {formatDate(this.props.profile.createdAt)}
              </li>
            </ul>
          </div>
          <ProfileStatus
            actions={this.props.actions}
            profile={this.props.profile}
            isLoading={this.props.isLoading}
          />
          {this.props.auditLog.length ? (
            <AuditTable
              actions={this.props.actions}
              auditLog={this.props.auditLog}
              profile={this.props.profile}
              isLoading={this.props.isLoading}
            />
          ) : null}
        </div>
      );
    else
      return (
        <div className="profile-status-pane">
          <div className="profile-current">
            {formatMessage({ id: this.getI18nID('audit.profileNotFound') })}
          </div>
        </div>
      );
  }
}

SelectionProfileStatus.contextTypes = {
  router: PropTypes.object
};

SelectionProfileStatus.propTypes = {
  actions: PropTypes.object,
  auditLog: PropTypes.array,
  profile: PropTypes.object,
  isLoading: PropTypes.bool,
  location: PropTypes.object
};

export default injectIntl(SelectionProfileStatus);
